import axios from "axios";
import { cachedRead } from "../../../offline";
import { createResource } from "../../../offline/resource";
import { summarizeMeasurement } from "./geometry";

const base = `${process.env.REACT_APP_BACKEND_URL}/measurements`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

// Measurements can be opened, created and edited without a connection (src/offline); they are
// uploaded when the device is online again.
const measurements = createResource({
  module: "measurements",
  base,
  auth: headers,
  idPath: "_id",
  versionPath: "updatedAt",
  unwrap: data => data,
  wrap: view => view,
  label: body => body.title || "",
  blank: async (body, localId) => ({
    _id: localId,
    title: "",
    date: "",
    project: null,
    address: "",
    notes: "",
    dictation: "",
    rooms: [],
    ...body
  }),
  // List row of a measurement created offline: the totals the server would store
  toRow: view => {
    const summary = summarizeMeasurement(view.rooms || [], view.rules);
    return {
      ...view,
      totals: summary.totals,
      roomCount: summary.roomCount,
      warningCount: summary.warningCount
    };
  }
});

export const getMeta = () =>
  cachedRead("measurements:meta", () => axios.get(`${base}/meta`, headers()));
export const listMeasurements = filters =>
  measurements.list(JSON.stringify(filters || {}), () =>
    axios.post(`${base}/list`, filters, headers())
  );
export const getMeasurement = id => measurements.get(id);
export const createMeasurement = body => measurements.create(body);
export const updateMeasurement = (id, body) => measurements.update(id, body);
export const deleteMeasurement = id =>
  measurements.remove(id, serverId => axios.delete(`${base}/${serverId}`, headers()));

export const transcribeAudio = (blob, language) => {
  const body = new FormData();
  body.append("audio", blob, "dictation.wav");
  body.append("language", language);
  return axios.post(`${base}/voice/transcribe`, body, headers());
};

export const parseDictation = (text, language, rules) =>
  axios.post(`${base}/voice/parse`, { text, language, rules }, headers());

// Projects the user may see (server-scoped), for linking a measurement.
export const fetchProjects = () =>
  cachedRead("projects:limited", () =>
    axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/projects/limited`,
      { pageSize: 200 },
      headers()
    )
  ).then(res => (Array.isArray(res.data?.data) ? res.data.data : []));
